module.exports = __webpack_public_path__ + "static/img/content4.0896ef4f.png";